import { investorPortalPages } from "./routes/investorPortalPages";
import { sponsorDashboardPages } from "./routes/sponsorDashboardPages";

export default function getRoutes(isSponsorDashboard: boolean) {
  if (isSponsorDashboard) return sponsorDashboardPages;
  return investorPortalPages;
}
